import { motion } from "framer-motion";
import { Search, BarChart3, Trophy } from "lucide-react";

const steps = [
  { num: "1", title: "Ask naturally", desc: "Type what you need. Budget, use case, preferences.", icon: Search },
  { num: "2", title: "We do the hard work", desc: "Cross-retailer price checks, trust scoring, landed cost calculation.", icon: BarChart3 },
  { num: "3", title: "One clear winner", desc: "Best Overall. Best Value. Fastest. With full reasoning.", icon: Trophy },
];

export default function HowItWorks() {
  return (
    <section className="w-full max-w-md mx-auto py-8 sm:py-12 px-4">
      <motion.h2
        initial={{ opacity: 0, y: 12 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.4 }}
        className="text-lg sm:text-xl font-display font-bold text-foreground text-center mb-5"
      >
        How it works
      </motion.h2>
      <div className="flex flex-col gap-4 items-center">
        {steps.map((s, i) => {
          const Icon = s.icon;
          return (
            <motion.div
              key={s.num}
              initial={{ opacity: 0, y: 8 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.25, delay: i * 0.06 }}
              className="text-center max-w-xs"
            >
              <div className="flex items-center justify-center gap-2 mb-1">
                <span className="text-xs font-display font-bold text-primary">{s.num}</span>
                <Icon className="w-3.5 h-3.5 text-primary/70" />
              </div>
              <p className="text-sm font-body font-semibold text-foreground">{s.title}</p>
              <p className="text-xs font-body text-muted-foreground mt-0.5">{s.desc}</p>
            </motion.div>
          );
        })}
      </div>
    </section>
  );
}
